import styled from 'styled-components';
import { mediaQueries } from '@general/breakpoints';

const SubnavMobileStyled = styled.ul`
    list-style: none;
    padding-left: 0;
    text-align: center;

    @media ${mediaQueries.lg} {
        display: none;
    }
`;

export default SubnavMobileStyled;
